export var PropertyType;
(function(PropertyType) {
    PropertyType["SmallText"] = "small-text";
    PropertyType["LongText"] = "long-text";
    PropertyType["Number"] = "number";
    PropertyType["Date"] = "date";
    PropertyType["Time"] = "time";
    PropertyType["Duration"] = "duration";
    PropertyType["SingleSelect"] = "single-select";
    PropertyType["MultiSelect"] = "multi-select";
    PropertyType["Media"] = "media";
})(PropertyType || (PropertyType = {}));
export const PropertyTypeLabels = {
    ["small-text"]: 'Small Text',
    ["long-text"]: 'Long Text',
    ["number"]: 'Number',
    ["date"]: 'Date',
    ["time"]: 'Time',
    ["duration"]: 'Duration',
    ["single-select"]: 'Single Select',
    ["multi-select"]: 'Multi Select',
    ["media"]: 'Media'
};

//# sourceMappingURL=property.types.js.map